






























































import {Vue, Component} from 'vue-property-decorator'

import Information from '@/components/Information.vue'
import Status from '@/components/Status.vue'
import { Server } from '@/store/server'
import { getModule } from 'vuex-module-decorators'
import informationContent from '@/assets/information.yaml'
@Component({
  components: {
      Information, Status
  }
})
export default class InformationView extends Vue {
  mounted() {
    this.server.getStatus()
  }

  get server() {
    return getModule(Server)
  }
  
  get informationEntries() {
      return informationContent.content
  }
}
